import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getFormStatus = basicSelector(state => state.formStatus);
export const getIsFormValid = createSelector([getFormStatus], formStatus => formStatus.isValid);